const REJECT_REASONS = {
  NI_C2C_RECURRING_WARNING: 'NI_C2C_RECURRING_WARNING',
  NI_REACTIVATION_GIFT_CARD_RECURRING_WARNING:
    'NI_REACTIVATION_GIFT_CARD_RECURRING_WARNING',
  NI_REACTIVATION_GIFT_CARD_MINIMUM_AMOUNT_WARNING:
    'NI_REACTIVATION_GIFT_CARD_MINIMUM_AMOUNT_WARNING'
};

export const REFERRAL_REJECT_MESSAGES = [
  {
    rejectReason: REJECT_REASONS.NI_C2C_RECURRING_WARNING,
    message:
      'Your $20 credit can only be applied to our pay-as-you-go option with no predefined end date. You can still cancel anytime.'
  },
  {
    rejectReason: REJECT_REASONS.NI_REACTIVATION_GIFT_CARD_MINIMUM_AMOUNT_WARNING,
    message: 'Your credit can only be applied to a policy of minimum 1$.'
  },
  {
    rejectReason: REJECT_REASONS.NI_REACTIVATION_GIFT_CARD_RECURRING_WARNING,
    message:
      'Your $20 gift card credit can only be applied to our pay-as-you-go option with no predefined end date. You can still cancel anytime.'
  }
];
